/**
 * Telegram-id's van chatters: alleen cijfers (2-11-2026, Jordy).
 *
 * Twee chatters hadden een @gebruikersnaam als Telegram Chat ID; daar kan de
 * bot niet naartoe sturen, dus hun meldingen kwamen nooit aan. Dezelfde regel
 * als de server (src/services/telegram_id.py): leeg mag, anders een getal van
 * 5–20 cijfers, negatief voor een groep (-100…). Alleen een gewijzigde waarde
 * wordt gecontroleerd, zodat een oude foute waarde andere wijzigingen niet
 * blokkeert.
 */
export const TELEGRAM_ID_HINT = 'Number from @userinfobot — not your @username'

export function telegramIdFout(waarde: string, veld: string, huidig?: string | null): string {
  const schoon = waarde.trim()
  if (!schoon || schoon === (huidig ?? '').trim()) return ''
  return /^-?[0-9]{5,20}$/.test(schoon) ? '' : `${veld} must be a number, not a @username`
}
